import {
  FETCHING_LIBRARY_IMAGES, FETCHING_LIBRARY_IMAGES_SUCCEEDED, FETCHING_LIBRARY_IMAGES_FAILED,
  INVALIDATE_LIBRARY_IMAGES, FETCHING_MEDIA_LIBRARY_CATEGORIES,FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED,
  FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED,
  FETCHING_MEDIA_LIBRARY_FOR_CATEGORY,
  FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_FAILED,
  FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_SUCCEEDED
} from './actionTypes.jsx';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;


const IMAGE_LIBRARY_BASE_URL = `${apiUrl}/api/2.0/image_library`;
const MEDIA_LIBRARY_BASE_URL = `${apiUrl}/api/2.0/media_library_category`;

export function fetchLibraryImages(page, type, mediaType) {
  return function (dispatch) {
    dispatch(fetchingLibraryImages(type, mediaType));

    let data = {
      entityType: type,
      mediaType: mediaType,
      page: page,
      limit: 40
    }


    return axios({
      method: 'POST',
      url: `${IMAGE_LIBRARY_BASE_URL}`,
      data: data
    })
    .then(response => {
      dispatch(fetchingLibraryImagesSuccedded(type, mediaType, response.data))
    })
    .catch(error => {
      dispatch(fetchingLibraryImagesFailed(type, mediaType, error))
    })
  }
}

function fetchingLibraryImages(type) {
  return {
    type: FETCHING_LIBRARY_IMAGES,
    payload: type
  }
}

function fetchingLibraryImagesSuccedded(type, mediaType, json) {
  return {
    type: FETCHING_LIBRARY_IMAGES_SUCCEEDED,
    payload: {
      type: type,
      mediaType: mediaType,
      images: json
    }
  }
}

function fetchingLibraryImagesFailed(type, mediaType, error) {
  return {
    type: FETCHING_LIBRARY_IMAGES_FAILED,
    payload: {
      type: type,
      mediaType: mediaType,
      error: error
    }
  }
}

export function invalidateLibraryImages(type) {
  return {
    type: INVALIDATE_LIBRARY_IMAGES,
    payload: type
  }
}

  
export function fetchMediaLibraryCategories(type) {
  return function (dispatch) {
    dispatch(fetchingMediaLibraryCategories(type));

    var params = {
      type: type
    }

    return axios({
      method: 'GET',
      url: `${MEDIA_LIBRARY_BASE_URL}/categories`,
      params: params
    })
    .then(response => {
      dispatch(fetchingMediaLibraryCategoriesSuccedded(type, response.data))
    })
    .catch(error => {
      dispatch(fetchingMediaLibraryCategoriesFailed(type, error))
    })
  }
}

function fetchingMediaLibraryCategories(type) {
  return {
    type: FETCHING_MEDIA_LIBRARY_CATEGORIES,
    payload: type
  }
}

function fetchingMediaLibraryCategoriesSuccedded(type, json) {
  return {
    type: FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED,
    payload: {
      type: type,
      categories: json
    }
  }
}

function fetchingMediaLibraryCategoriesFailed(type, error) {
  return {
    type: FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED,
    payload: {
      type: type,
      error: error
    }
  }
}

// Fetch Media For Category Id
export function fetchMediaLibraryForCategory(categoryId, type, mediaType) {
  return function (dispatch) {
    dispatch(fetchingMediaLibraryForCategory(categoryId, type, mediaType));

    var data = {
      categoryId: categoryId,
      mediaType: mediaType,
      limit: 40,
      page: 0
    }

    return axios({
      method: 'POST',
      url: `${IMAGE_LIBRARY_BASE_URL}/categories`,
      data: data
    })
    .then(response => {
      dispatch(fetchingMediaLibraryForCategorySuccedded(response.data, categoryId, type, mediaType))
    })
    .catch(error => {
      console.log({error})
      dispatch(fetchingMediaLibraryForCategoryFailed(error, type, mediaType))
    })
  }
}

function fetchingMediaLibraryForCategory(categoryId, type, mediaType) {
  return {
    type: FETCHING_MEDIA_LIBRARY_FOR_CATEGORY,
    payload: {
      type: type,
      categoryId: categoryId,
      mediaType: mediaType
    }
  }
}

function fetchingMediaLibraryForCategorySuccedded(json, categoryId, type, mediaType) {
  return {
    type: FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_SUCCEEDED,
    payload: {
      images: json,
      categoryId: categoryId,
      type: type,
      mediaType: mediaType
    }
  }
}

function fetchingMediaLibraryForCategoryFailed(error, type, mediaType) {
  return {
    type: FETCHING_MEDIA_LIBRARY_FOR_CATEGORY_FAILED,
    payload: {
      type: type,
      mediaType: mediaType,
      error: error
    }
  }
}